/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gh-letter-template-tab-container',
  templateUrl: 'letter-template-tab-container.component.html',
})
export class LetterTemplateTabContainerComponent {

}
